import React from 'react';

import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { useUserRegistrationByInviteMutation } from 'src/api';
import { Button } from 'src/components/common';
import { useNotification } from 'src/hooks/app';
import { useAppAuth, useAuthSignup } from 'src/hooks/auth';
import type { SxProp } from 'src/types/mui';

export const YourCompanyExistInfoBlock: React.FC = () => {
  const navigate = useNavigate();

  const { formData, inviteData, prepareFormData } = useAuthSignup();
  const { setAuthState } = useAppAuth();
  const { createApolloContext } = useNotification();

  const [signUpUserByInvite, { loading: userRegistrationLoading }] =
    useUserRegistrationByInviteMutation({ context: createApolloContext() });

  const handleSubmit = React.useCallback(async () => {
    try {
      const { data } = await signUpUserByInvite({
        variables: prepareFormData(String(inviteData?.id), formData),
      });
      await setAuthState({
        bearerToken: String(data?.userRegistrationByInvite.idToken),
        accessToken: data?.userRegistrationByInvite.accessToken ?? undefined,
      });
      navigate(appRoutes.auth.setupMfa);
    } catch (error) {
      console.error(error);
    }
  }, [signUpUserByInvite, prepareFormData, inviteData?.id, formData, setAuthState, navigate]);

  return (
    <Box>
      <Typography variant="h5">Your company exists already on Clear Verify</Typography>

      <Typography variant="body1" color="text.secondary">
        It appear that your company has already signed up in Clear Verify. For this reason, we
        cannot accept the Company Information you provided. You can check and edit information as
        needed in the Company Information section under My Account.
      </Typography>

      <Box display="flex" justifyContent="center" mt={4}>
        <Button
          onClick={handleSubmit}
          loading={userRegistrationLoading}
          disabled={userRegistrationLoading}
          sx={submitButtonStyles}
          size="large"
          variant="contained"
        >
          Go to the dashboard
        </Button>
      </Box>
    </Box>
  );
};

const submitButtonStyles: SxProp = {
  px: 5,
};
